<template>

    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" id="survey" style="text-align: center; padding: 0px;">

        <div class="content-body-container col-md-12">
            <!-- <div class="backstretch">
                <img v-if="isBigScreenWidth" src="../assets/bg.png"/>
                <img v-if="!isBigScreenWidth" src="../assets/mobilebg.jpg"/>
            </div> -->

            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <h4 class="td-default-title">Device Readiness / 电子设备</h4>

                <label>
                    Dear Parents, 
                    <br/><br/>
                    We would like to conduct a 1-question survey on Home-Based Learning (HBL) for contingency purposes. We look forward to receiving your response by Wednesday, 19 May 2021.
                    <br/><br/>
                    Thank you.

                    <br/><br/>

                    亲爱的各位家长，
                    <br/><br/>
                    您好！我们创建了一个问卷调查，为做好居家学习(HBL)的准备，以备应急之需。此调查只有一个问题。我们期待在2021年5月19日(星期三)之前收到您的回复。
                    <br/><br/>
                    谢谢!
                </label>

                <div class="form-group" style="text-align: left; margin-top: 30px;">
                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <h5>Does your household have at least 1 device to support your child/children for HBL?
                            <br/>
                            您家里是否至少具备一台电子设备支持您的孩子进行居家学习HBL?
                        </h5>

                        <section>
                            <input type="radio" v-model="haveDevices" value="Y" style="margin-right: 10px;">Yes
                            <span style="display: inline-block; width: 30px;"></span>
                            <input type="radio" v-model="haveDevices" value="N" style="margin-right: 10px;">No
                        </section>
                    </div>
                </div>

                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" style="margin: 20px 0 0 0;">
                    <el-button type="primary" style="float: right;" @click="saveSurvey()">Submit / 提交</el-button>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    import Vue from 'vue';
    import DataSource from "../data/datasource";
    import Cookies from "js-cookie";
    import moment from 'moment';
    import {lang} from '../locale/index';

    export default {
        name: "Survey",
        components: {

        },
        data(){
            return {
                isBigScreenWidth: true,
                haveDevices: "",
                lblParentID: "",
                parentInfo: [],
            }
        },
        async mounted() {
            this.isMobile();

            if (Cookies.get('userTypeSession') === 'Parent') {
                await this.getConDetails();
                await this.loadParentInfo();
            }

            $(document).ready(function(){
                $(".content-body-container").css("min-height", window.outerHeight);
            });
        },
        methods: {
            lang,

            async loadParentInfo() {
                this.$vs.loading();
                try {
                    if (Cookies.get('userIDSession') !== null || Cookies.get('userIDSession') !== undefined) {
                        const response = await DataSource.shared.getParentStudentsInfo(Cookies.get('userIDSession'));

                        if (response) {
                            if (response.code === "2") {
                                this.$notify.error({
                                    title: 'Error',
                                    message: 'No record found'
                                });
                            } else if (response.code === "99") {
                                this.$notify.error({
                                    title: 'Error',
                                    message: 'Please try again later'
                                });
                            } else {
                                this.parentInfo = response.Parent;
                                this.haveDevices = this.parentInfo[0].ParentHasDevice;
                            }
                        }
                    }
                } catch (e) {
                    this.results = e;
                }
                this.$vs.loading.close();
            },

            async getConDetails() {
                try {
                    if (Cookies.get('userIDSession') !== null || Cookies.get('userIDSession') !== undefined) {
                        const response = await DataSource.shared.getUserDetailsByCONID(Cookies.get('userIDSession'));

                        if (response) {
                            if (response.code === "2") {
                                this.$notify.error({
                                    title: 'Error',
                                    message: 'No record found'
                                });
                            } else if (response.code === "99") {
                                this.$notify.error({
                                    title: 'Error',
                                    message: 'Please try again later'
                                });
                            } else {
                                if (response.Table) {
                                    this.lblParentID = response.Table[0].CONparid;
                                }
                                console.log(this.lblParentID, "sada");
                            }
                        }
                    }
                } catch (e) {
                    this.results = e;
                }
            },

            async saveSurvey() {

                if (this.haveDevices === "") {
                    this.$notify.error({
                        title: lang('Error'),
                        message: lang('Please select Yes or No!')
                    });
                    return ;
                }

                let jsonParent = [];
                let jsonParentDetials = {
                    PAR_Has_Device : this.haveDevices,
                };
                // let jsonString = '"PAR_Has_Device":"' + haveDevices + '"';
                jsonParent.push(jsonParentDetials);

                const response = await DataSource.shared.updateParent(this.lblParentID, JSON.stringify(jsonParent));
                if (response) {
                    if (response.code == "1") {
                        this.$notify({
                            title: lang('Success'),
                            message: lang('Records Successfully Edited'),
                            type: 'success'
                        });

                    } else {
                        this.$notify.error({
                            title: lang('Error'),
                            message: lang('Update Parent Error - Please try again later')
                        });
                    }
                }
            },

            isNull(obj) {
                return (obj === null || obj === undefined || obj === "undefined" || obj.length === 0);
            },

            isMobile() {
                if (window.innerWidth <= 760) {
                    this.isBigScreenWidth = false;
                } else {
                    this.isBigScreenWidth = true;
                }
            },
        },
        created() {
            window.addEventListener("resize", this.isMobile);
        },
        destroyed() {
            window.removeEventListener("resize", this.isMobile);
        },
    }
</script>

<style scoped>
    .content-body-container {
        display: inline-block;
        padding: 20px;
        background: white;
    }

    #survey .backstretch {
        top: 0px;
        left: 0px;
        width: 100%;
        height: 100%;
        overflow: hidden;
        /*position: fixed;*/
        position: absolute;
    }

    #survey .backstretch img {
        height: 100%;
        width: 100%;
    }
</style>

<style>
    .survey #main-content {
        padding: 0px;
    }

    .survey .topbar {
        /*position: sticky;*/
        top: 0px;
    }
</style>